var _excluded = ["color", "component", "size"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import styled from 'styled-components';
var IconContainer = styled.span.withConfig({
  componentId: "CL__sc-1ubbd61-0"
})(["display:inline-block;color:", ";--icon-size:", ";height:var(--icon-size) !important;width:var(--icon-size) !important;& svg{display:block;height:var(--icon-size) !important;width:var(--icon-size) !important;}"], _ref => {
  var {
    color
  } = _ref;
  return color;
}, _ref2 => {
  var {
    size
  } = _ref2;
  return size === 'small' ? '16px' : size === 'medium' ? '20px' : size === 'large' ? '24px' : "".concat(size, "px");
});
var Icon = /*#__PURE__*/React.forwardRef((_ref3, ref) => {
  var {
      color = 'inherit',
      component,
      size = 36
    } = _ref3,
    props = _objectWithoutProperties(_ref3, _excluded);
  try {
    return /*#__PURE__*/React.createElement(IconContainer, _extends({
      "aria-label": "Icon: ".concat(component.name),
      color: color,
      ref: ref,
      role: "img",
      size: size
    }, props), component());
  } catch (_) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
});
export default Icon;